import { render, staticRenderFns } from "./gallery_slider.vue?vue&type=template&id=551f6137&scoped=true"
import script from "./gallery_slider.vue?vue&type=script&lang=js"
export * from "./gallery_slider.vue?vue&type=script&lang=js"
import style0 from "./gallery_slider.vue?vue&type=style&index=0&id=551f6137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551f6137",
  null
  
)

export default component.exports